import React, { useEffect } from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import { getActiveOrMatchingFacilities } from "reduxSlices/facilitiesSlice"
import InactiveOptionsItemRenderer from "shared/selects/InactiveOptionsItemRenderer"
import { ListSelect } from "shared/selects"

const facilityOptions = (facilities) => facilities.map((facility) => (
  { label: facility.name, value: facility.id, active: facility.active }
))

const LocationIsFacilityMatchValueInput = ({
  className = "",
  isFullWidth,
  onChange,
  value = null,
}) => {
  const facilities = useSelector(getActiveOrMatchingFacilities(value))

  const { nameInSentence: facilityNameInSentence } = useCustomName(FACILITY_KEY)

  useEffect(() => {
    if (!value && facilities.length !== 0) {
      onChange(facilities[0].id)
    }
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [value, facilities])

  return (
    <ListSelect
      backspaceDelete={false}
      className={className}
      isFullWidth={isFullWidth}
      itemRenderer={InactiveOptionsItemRenderer}
      onChange={onChange}
      options={facilities}
      optionsFromList={facilityOptions}
      required
      value={value}
      label={`select ${facilityNameInSentence} where question will be shown if ${facilityNameInSentence} is the answer`}
    />
  )
}

LocationIsFacilityMatchValueInput.propTypes = {
  className: types.string,
  isFullWidth: types.bool.isRequired,
  onChange: types.func.isRequired,
  value: types.number,
}

export default LocationIsFacilityMatchValueInput
